
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import { dispatch, ListQuery, Comment, User } from "@/store";

export default Vue.extend({
  data() {
    return {
      query: {
        page_number: 1,
        page_size: 10,
        ordering: "-id",
        content_type: "coin_task",
        user_id: -1
      } as ListQuery,
      list: [] as Comment[],
      user: {} as User,
      count: 0
    };
  },
  computed: {
    ...mapGetters({ allow: "allow" }),
    ...mapGetters({ coinName: "coinName" }),
    ...mapState({
      currentUser: "user",
      notifications: "notifications"
    }),
    ...mapState("app", {
      language: "language",
      isMobile: "isMobile"
    }),
    ...mapState("assets", {
      images: "images"
    }),
    ...mapState("tasks", {}),
    viewedId(): number {
      const { id } = this.$route.params;
      return id ? Number(id) : 0;
    },
    unread(): number {
      return this.notifications.unreadCount > 99
        ? 99
        : this.notifications.unreadCount;
    }
  },
  methods: {
    tasksMentionedList(query: ListQuery) {
      return dispatch.tasksGetList(query);
    },
    tasksGetCommentList(query: ListQuery) {
      return dispatch.userTaskRecord(query);
    },
    onUserEdit() {
      if (this.viewedId) {
        return;
      }
      this.$router.push(this.$paths.userEdit);
    },
    onCoinRuleClick() {
      window.open("https://www.angrymiao.com/dao/479/", "_black");
    }
  },
  mounted() {
    if (!this.currentUser.isSignIn) {
      dispatch.userSignIn();
    } else if (this.viewedId) {
      if (this.viewedId === this.currentUser.id) {
        this.$router.replace(this.$paths.userCenter);
        return;
      }
      dispatch.userBalance();
      dispatch.userGetById(this.viewedId).then(res => {
        if (res) {
          this.user = res;
          this.query.user_id = this.user.id;
        }
      });
    }
  }
});
